import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";
import Alert from "react-s-alert";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const application = new Schema("applications", { idAttribute: "uid" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 15,
        offset: 0,
        sortDir: "desc",
        sortField: "createdAt"
      },
      "meta"
    ))(),
    deleteStatus: 0
  },
  "application"
);

const applicationsReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.GET_APPLICATIONS_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { applications: arrayOf(application) });
      return state
        .update("map", map => map.merge(nrs.entities.applications))
        .update("results", rs => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_APPLICATION_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, application);
      return state.update("map", map => map.merge(nrs.entities.applications));
    }

    case actions.DELETE_APPLICATION: {
      return state.setIn(["deleteStatus"], 1);
    }

    case actions.DELETE_APPLICATION_SUCCESS: {
      return state.setIn(["deleteStatus"], 2);
    }

    case actions.DELETE_APPLICATION_ERROR: {
      return state.setIn(["deleteStatus"], 3);
    }

    case actions.SET_DELETE_STATUS: {
      const { status } = action.payload;
      return state.setIn(["deleteStatus"], status);
    }

    case actions.SET_APPLICATION_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_APPLICATION_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    default:
      return state;
  }
};

export default applicationsReducer;



// WEBPACK FOOTER //
// ./src/common/application/reducer.js